module.exports = __webpack_public_path__ + "img/logo-hotels.00215810.jpg";